export const ACCOUNT_MAIN_CURRENCY = 'CVE'

export const ACCOUNT_TYPES = {
	CA: 'CA',
	CB: 'CB',
	CC: 'CC',
	CD: 'CD',
	CE: 'CE',
	CG: 'CG',
	CH: 'CH',
	CI: 'CI', // Investment account
	CN: 'CN',
	CV: 'CV',
	CR: 'CR', // Credit
	DP: 'DP', // Term deposit
	C3: 'C3',
	C6: 'C6'
}

export const ACCOUNT_FAMILIES = {
	liabilities: 'liabilities',
	assets: 'assets'
}

export const CV_BANK_CODES = ['0002', '0003', '0004', '0005', '0006', '0007', '0008', '0009', '0011']
